import "../styles/global.scss";
import "../src/fonts";

import type { AppProps } from "next/app";
import { ConfirmProvider } from "material-ui-confirm";
import { CssBaseline } from "@mui/material";

import { ModalProvider } from "../src/contexts/ModalContext";
import { CustomThemeProvider } from "../src/contexts/CustomThemeProvider";
import GA4Tag from "../src/components/GA4/GA4Tag";
import { AuthProvider } from "src/contexts/AuthContext";
import { ReactQueryProvider } from "src/contexts/ReactQueryProvider";
import { ToastProvider } from "src/contexts/ToastContextProvider";
import { GlobalGenderModal } from "../src/components/Modal/GlobalGenderModal";
import { confirmDialogOptions } from "../src/components/ConfirmDialog/confirmDialog.options";

interface MyAppProps extends AppProps {}

function MyApp({ Component, pageProps }: MyAppProps) {
  return (
    <ConfirmProvider defaultOptions={confirmDialogOptions}>
      <GA4Tag />
      <Component {...pageProps} />
      <GlobalGenderModal />
    </ConfirmProvider>
  );
}

function MyAppWrapper({ Component, pageProps, router }: MyAppProps) {
  return (
    <CustomThemeProvider>
      <CssBaseline />
      <ReactQueryProvider>
        <ToastProvider>
          <AuthProvider>
            <ModalProvider>
              <MyApp
                Component={Component}
                pageProps={pageProps}
                router={router}
              />
            </ModalProvider>
          </AuthProvider>
        </ToastProvider>
      </ReactQueryProvider>
    </CustomThemeProvider>
  );
}

export default MyAppWrapper;
